import { Link, useLocation, useNavigate } from "react-router-dom";

export const Footer = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const goToSection = (hash) => {
    if (pathname !== "/") {
      navigate("/" + hash);
    } else {
      document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer
      data-testid="footer"
      className="border-t border-white/5 px-6 py-16 lg:px-10"
    >
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-8 text-center">
        <button
          onClick={() => {
            if (pathname !== "/") navigate("/");
            else window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-2.5"
          data-testid="footer-logo"
        >
          <span className="relative flex h-2.5 w-2.5">
            <span className="absolute inline-flex h-full w-full rounded-full bg-[#c9a84c] opacity-60 breathe" />
            <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-[#e8c97a]" />
          </span>
          <span className="text-sm font-semibold uppercase tracking-[0.32em] text-white">
            Nuit&nbsp;Calme
          </span>
        </button>

        <nav className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3">
          {[
            ["Le programme", "#program"],
            ["Tarifs", "#pricing"],
            ["Avis", "#testimonials"],
            ["FAQ", "#faq"],
          ].map(([label, href]) => (
            <button
              key={href}
              data-testid={`footer-link-${href.replace("#", "")}`}
              onClick={() => goToSection(href)}
              className="text-sm text-white/50 transition-colors duration-300 hover:text-white"
            >
              {label}
            </button>
          ))}
          <Link
            to="/mentions-legales"
            data-testid="footer-link-mentions-legales"
            className="text-sm text-white/50 transition-colors duration-300 hover:text-white"
          >
            Mentions légales
          </Link>
          <Link
            to="/cgv"
            data-testid="footer-link-cgv"
            className="text-sm text-white/50 transition-colors duration-300 hover:text-white"
          >
            CGV
          </Link>
        </nav>

        <p className="max-w-lg text-xs leading-relaxed text-white/35">
          NUIT CALME est un programme de bien-être et d’hygiène du sommeil. Ceci
          n’est pas un dispositif médical et ne remplace pas l’avis d’un
          professionnel de santé.
        </p>

        <p className="text-xs text-white/40">
          <a
            href="mailto:contact@nuitcalme.eu"
            data-testid="footer-email"
            className="transition-colors duration-300 hover:text-[#e8c97a]"
          >
            contact@nuitcalme.eu
          </a>
          <span className="mx-2 text-white/20">·</span>
          <a
            href="https://nuitcalme.eu"
            data-testid="footer-domain"
            className="transition-colors duration-300 hover:text-[#e8c97a]"
          >
            nuitcalme.eu
          </a>
        </p>

        <p className="text-xs text-white/30">
          © {new Date().getFullYear()} NUIT CALME · Fait avec soin pour tes nuits.
        </p>
      </div>
    </footer>
  );
};
